import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { Form } from './form/form.component';
import { FastActionNetworkForm } from './form/fastActionNetworkForm';
import { TakeActionForm } from './form/takeActionForm';
import { EventsForm } from './form/eventsForm';
import './formStyles.forms.scss';
import { FrameContent, BoxShadow } from './iframeForm.styles';
import { SubscribeForm } from './form/subscribeForm';
import { identifiers } from '../../utils/rendering';
import { colors } from '../../theme/styled';

export const FormType = {
  SUBSCRIBE: 'subscription',
  FAST_ACTION_NETWORK: 'FAN',
  TAKE_ACTION: 'takeAction',
  OTHER_IFRAME: 'other (iframe)',
  EVENTS: 'event',
};

/**
 * Renders an iframe with an form inside.
 * The form type is determined based on _type_ prop. Depending on the type, the form behaves in a different way.
 * (ie. it triggers specific funnel status updates, or it is modified in specific way to match the design)
 **/
export class IframeForm extends PureComponent {
  /**
   * PropTypes
   * @property type - type of the form.
   * Types DONATE, SUBSCRIBE, FAST_ACTION_NETWORK and TYPE_ACTION describe EveryAction forms with specigic behavior.
   * OTHER_IFRAME defines a platform agnostic form type that needs to reside inside the iframe
   **/
  static propTypes = {
    contentType: PropTypes.string.isRequired,
    entryId: PropTypes.string.isRequired,
    scriptSrc: PropTypes.string,
    name: PropTypes.string,
    embededElement: PropTypes.string,
    type: PropTypes.string,
    customClass: PropTypes.string,
    headerHeight: PropTypes.any,
    onFormRendered: PropTypes.func,
    boxWrap: PropTypes.bool,
  };

  render() {
    const { contentType, entryId, name, type, boxWrap } = this.props;
    const ConditionalWrapper = ({ condition, wrapper, children }) =>
      condition ? wrapper(children) : children;

    return (
      <ConditionalWrapper
        condition={boxWrap}
        wrapper={children => (
          <BoxShadow backgroundColor={colors.darkGrey} hideCorner={false} hideShadow>
            {children}
          </BoxShadow>
        )}
      >
        <FrameContent
          {...identifiers('IframeForm', contentType, entryId)}
          stylesheetSrc={'/form-styles.css'}
          title={name}
          type={type}
        >
          {({ host, hostWindow }) => {
            const formProps = {
              ...this.props,
              host,
              hostWindow,
            };

            if (type === FormType.FAST_ACTION_NETWORK) {
              return <FastActionNetworkForm {...formProps} />;
            }

            if (type === FormType.TAKE_ACTION) {
              return <TakeActionForm {...formProps} />;
            }

            if (type === FormType.SUBSCRIBE) {
              return <SubscribeForm {...formProps} />;
            }

            if (type === FormType.OTHER_IFRAME) {
              return <Form {...formProps} customClass="form--other-iframe" />;
            }

            if (type === FormType.EVENTS) {
              return <EventsForm {...formProps} />;
            }

            return <Form {...formProps} />;
          }}
        </FrameContent>
      </ConditionalWrapper>
    );
  }
}
